const req = require.context("../../interventions/", true, /type.js$/);
// código comentado pois estava duplicando os paths
// const modules = req.keys().map(req);

// let works = [ ];

// modules.forEach((module) => {
//     const isActive = activeModules.findIndex((item) => item === module.default.key) >= 0;
//     works.push({
//         ...module.default,
//         active: isActive,
//     });
// });

const moduleMap = {};

req.keys().forEach((key) => {
  const normalizedKey = key;
  const module = req(key).default;

  if(moduleMap[module.key]) return;

  moduleMap[module.key] = normalizedKey;
});

const activeModules = [
    'parish_interventions',
    'municipal_interventions',
    // 'other_occupations',
    // 'municipal_works',
];

let works = Object.keys(moduleMap).map((key) => {
    const isActive = activeModules.includes(key);
    return {
      ...req(moduleMap[key]).default,
      active: isActive,
    };
  });

export const typeOfInterventions = works;

export const getWork = (needle, keyToSearch = "key") => {
    return typeOfInterventions.find((item) => {
        if (item[keyToSearch] === needle) return item;
    });
};
